import { HttpClient } from '../httpClient';
import TreatmentsResponse from '../responses/treatmentsResponse';

const httpClient = new HttpClient();

export const getTreatments = async () => {
  return httpClient.get<TreatmentsResponse>({
    url: '/v1/treatments',
    requiresToken: true,
  });
};

export const getCaseloadTreatmentOptionsByCaseloadId = async (caseloadId: number) => {
  return httpClient.get<TreatmentsResponse>({
    url: `/v1/treatments/caseloadTreatmentOptionsByCaseloadId/${caseloadId}`,
    requiresToken: true,
  });
};

export const getCaseloadTreatmentOptionsByDisciplineId = async (disciplineId: number) => {
  return httpClient.get<TreatmentsResponse>({
    url: `/v1/treatments/caseloadTreatmentOptionsByDisciplineId/${disciplineId}`,
    requiresToken: true,
  });
};